/**
 * tl-card-add.js — carries a product card's chosen quantity into Horizon's
 * size popover for multi-variant products.
 *
 * On a card with a Size (etc.), "Add to cart" / "Buy with Shop" open the
 * quick-add size popover (handled declaratively by quick-add.js). This script
 * only bridges the quantity: when one of those openers is clicked and the card
 * quantity is >1, it watches the popover fill in and copies the value across.
 *
 * Fully defensive: it never blocks the click, no-ops if anything is missing,
 * and self-disconnects (and times out) so it can't leak observers. If it can't
 * set the quantity for any reason, the popover simply governs quantity as usual.
 */
(function () {
  'use strict';

  var MODAL_CONTENT_ID = 'quick-add-modal-content';
  var OPENER_SELECTOR = '.tl-card-add__choose, .tl-card-add__shoppay--choose';

  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest ? event.target.closest(OPENER_SELECTOR) : null;
      if (!opener) return;

      var zone = opener.closest('.tl-card-add');
      var cardQtyInput = zone && zone.querySelector('.tl-card-add__qty input');
      var qty = cardQtyInput ? parseInt(cardQtyInput.value, 10) : 1;
      if (!qty || qty < 2) return; // default quantity — nothing to carry

      var modalContent = document.getElementById(MODAL_CONTENT_ID);
      if (!modalContent) return;

      var applied = false;
      var apply = function () {
        if (applied) return;
        var modalQty = modalContent.querySelector('input[name="quantity"]');
        if (!modalQty) return;
        applied = true;
        modalQty.value = String(qty);
        modalQty.dispatchEvent(new Event('change', { bubbles: true }));
        observer.disconnect();
      };

      var observer = new MutationObserver(apply);
      observer.observe(modalContent, { childList: true, subtree: true });

      // The content may already be present (cached popover) — try immediately.
      apply();

      // Safety net: never observe indefinitely.
      window.setTimeout(function () {
        observer.disconnect();
      }, 4000);
    },
    true
  );
})();
